/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Created_Step_1Inputs */



/**
* | output |
* | --- |
* | "Send this link to the members." |
*
* @param {Team_Share_Created_Step_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_step_1 = /** @type {((inputs?: Team_Share_Created_Step_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_Step_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Send this link to the members.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Send this link to the members.")
	return /** @type {LocalizedString} */ ("Send this link to the members.")
});